// From https://gist.github.com/aMarCruz/31255d2afa5ce91a3acb

// Polyfill for IE 10 and Firefox <24, where classList.toggle does not
// support the second argument.

var c1 = 'c1';
var testElement = document.createElement('_');

testElement.classList.toggle(c1, true);

if (!testElement.classList.contains(c1)) {
    var _toggle = DOMTokenList.prototype.toggle;

    DOMTokenList.prototype.toggle = function (token, force) {
        if (1 in arguments && !this.contains(token) === !force) {
            return force;
        }
        return _toggle.call(this, token);
    };
}
